import { useTranslation } from "react-i18next";
import { Row, Col, Card, CardBody } from "react-bootstrap";
import crudApi from "@serie3/common/api/crudApi";
import { useEffect, useState } from "react";
import MessagesEndpoints from "@serie3/mymediaplanner/Modules/Messages/endpoints";
import { formatDate } from "@serie3/common/Shared/timeingStuff";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClockRotateLeft } from "@fortawesome/free-solid-svg-icons";

const getMonthKey = (dateStr) => {
  if (!dateStr) return "";
  const d = new Date(dateStr);
  if (isNaN(d)) return "";
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
};

const getMonthLabel = (dateStr) => {
  if (!dateStr) return "";
  const d = new Date(dateStr);
  if (isNaN(d)) return "";
  return d.toLocaleString("default", { month: "long", year: "numeric" });
};

const MessageLog = () => {
  const { t } = useTranslation();
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchMessags = async () => {
      await crudApi.getAll(MessagesEndpoints.getSent, setMessages, "messages");
      setLoading(false);
    };
    fetchMessags();
  }, []);

  let lastMonthKey = null;

  return (
    <>
      <h4 className="page-section-header">
        <span className="page-section-header-icon" style={{ background: "rgba(86,74,177,0.12)" }}>
          <FontAwesomeIcon icon={faClockRotateLeft} style={{ color: "#564ab1" }} />
        </span>
        {t("Backend.Outreach.Messages.MessagesLog")}
      </h4>
      <Card>
        <CardBody>
          <Row>
            <Col>
              {loading ? (
                <div style={{ padding: "8px 0" }}>
                  {[1, 2, 3, 4].map((i) => (
                    <div key={i} style={{ display: "flex", gap: 12, alignItems: "center", padding: "12px 0", borderBottom: "1px solid #f3f4f6" }}>
                      <div className="skeleton" style={{ width: 80, height: 14 }} />
                      <div className="skeleton" style={{ width: 120, height: 14 }} />
                      <div className="skeleton" style={{ flex: 1, height: 14 }} />
                    </div>
                  ))}
                </div>
              ) : (
              <div className="table-responsive">
                <table className="data-table">
                  <thead>
                    <tr>
                      <th style={{ width: 120 }}>Date</th>
                      <th style={{ width: 200 }}>Name</th>
                      <th>Message</th>
                    </tr>
                  </thead>
                  <tbody>
                    {messages.map((item, index) => {
                      const monthKey = getMonthKey(item.send_date);
                      const showSeparator = monthKey && monthKey !== lastMonthKey;
                      lastMonthKey = monthKey;
                      return (
                        <>
                          {showSeparator && (
                            <tr key={`sep-${monthKey}`} className="month-separator-row">
                              <td colSpan={3}>
                                <span className="month-separator-label">{getMonthLabel(item.send_date)}</span>
                              </td>
                            </tr>
                          )}
                          <tr key={index}>
                            <td style={{ color: "#9299a8", whiteSpace: "nowrap" }}>{formatDate(item.send_date)}</td>
                            <td>
                              <a href={item.url} target="_blank" rel="noreferrer"
                                style={{ fontWeight: 600, color: "#038edc", textDecoration: "none" }}>
                                {item.name}
                              </a>
                            </td>
                            <td style={{ color: "#6b7280" }}>{item.message}</td>
                          </tr>
                        </>
                      );
                    })}
                  </tbody>
                </table>
              </div>
              )}
            </Col>
          </Row>
        </CardBody>
      </Card>
    </>
  );
};

export default MessageLog;
